import React from 'react';
import { CustomImage } from '@vw-marketing/us-components';
import { AppConstants } from '../../utils/app-constants';
import { StyledTweetPlaceHolderContainer } from './styled';

const TweetPlaceholder = () => {
  return (
    <StyledTweetPlaceHolderContainer>
      <CustomImage
        src={AppConstants.PlaceHolder480x216}
        alt={'Loading....'}
        srcPlaceholder={AppConstants.PlaceHolder480x216}
      />
    </StyledTweetPlaceHolderContainer>
  );
};

export default TweetPlaceholder;
